<template>
  <div>
    <svg
      v-if="value"
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_15314_4060)">
        <circle cx="11.5007" cy="11.5" r="10.5417" fill="#43A047" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.6799 7.71819C17.0704 8.10871 17.0704 8.74188 16.6799 9.1324L10.5306 15.2817C10.343 15.4692 10.0887 15.5746 9.82346 15.5746C9.55824 15.5746 9.30389 15.4692 9.11635 15.2817L6.32121 12.4866C5.93069 12.096 5.93069 11.4629 6.32121 11.0724C6.71174 10.6818 7.3449 10.6818 7.73543 11.0724L9.82346 13.1604L15.2657 7.71819C15.6562 7.32766 16.2893 7.32766 16.6799 7.71819Z"
          fill="#112412"
        />
      </g>
      <defs>
        <clipPath id="clip0_15314_4060">
          <rect width="23" height="23" fill="white" />
        </clipPath>
      </defs>
    </svg>

    <svg
      v-else
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_15314_4060)">
        <circle cx="11.5007" cy="11.5" r="10.5417" fill="#43A047" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.6799 7.71819C17.0704 8.10871 17.0704 8.74188 16.6799 9.1324L10.5306 15.2817C10.343 15.4692 10.0887 15.5746 9.82346 15.5746C9.55824 15.5746 9.30389 15.4692 9.11635 15.2817L6.32121 12.4866C5.93069 12.096 5.93069 11.4629 6.32121 11.0724C6.71174 10.6818 7.3449 10.6818 7.73543 11.0724L9.82346 13.1604L15.2657 7.71819C15.6562 7.32766 16.2893 7.32766 16.6799 7.71819Z"
          fill="#112412"
        />
      </g>
      <defs>
        <clipPath id="clip0_15314_4060">
          <rect width="23" height="23" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<script setup>
defineProps({
  value: {
    type: Boolean,
    required: true,
  },
});
</script>

<style scoped lang="scss"></style>
